import React from "react";
import { Container, Typography, Paper } from "@mui/material";
import AppShell from "./AppShell";
import usePageTitle from "../hooks/usePageTitle";

const ArticleWelcome = () => {
  usePageTitle("Welcome");
  return (
    <AppShell>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ textAlign: "center" }}>
            Welcome to The Collector Stop
          </Typography>

          <Typography variant="body1" sx={{ textAlign: "center" }}>
            The Collector Stop helps you track your collection, estimate current market value, and monitor profit & loss over time. Search items across categories, add them to your collection, and view price confidence backed by recent comparable sales. Use the ticker for quick market movement and visit item details for history and comps.
          </Typography>
        </Paper>
      </Container>
    </AppShell>
  );
};

export default ArticleWelcome;
